import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllRaces = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetRaces}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getRaceById = async ({ companyCode,code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.RaceAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertRace = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.RaceAPI, input);
  return data;
};

const updateRace = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.RaceAPI, input);
  return data;
};

const deleteRace = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.RaceAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetRacesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetRaces],
    queryFn: () => getAllRaces(input),
    refetchOnWindowFocus: false,
    
  });
};

export const useGetRaceByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.RaceAPI],
    queryFn: () => getRaceById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertRaceMutation = () => {
  return useMutation({
    mutationFn: insertRace,
  });
};

export const useUpdateRaceMutation = () => {
  return useMutation({
    mutationFn: updateRace,
  });
};

export const useDeleteRaceMutation = () => {
  return useMutation({
    mutationFn: deleteRace,
  });
};
